module.exports = __webpack_public_path__ + "static/media/NJIT+RUN.9c29469d.jpg";